export async function getDisplayStream(){
    return await  navigator.mediaDevices.getDisplayMedia();
}